<template>
  <div class="kbx-step"
    :style="getStyle()">
    <percent v-if="stepListHasJumps"></percent>
    <numeric v-else></numeric>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Numeric from './numeric/Main';
import Percent from './percent/Main';

export default {
  components: {
    Numeric,
    Percent,
  },
  methods: {
    getStyle() {
      const styleProgress = this.stepStyle('progress');
      let display = styleProgress.display;

      if (styleProgress.display === null || styleProgress.display === undefined) {
        display = 'none';
      }

      return Object.assign(styleProgress, { display });
    },
  },
  computed: mapGetters({
    stepStyle: 'stepStyle',
    stepListHasJumps: 'stepListHasJumps',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?d3c9f5f2
 **/